import { Breadcrumb, Card, Col, Icon, Popconfirm, Row, Tabs, Tag, Tooltip } from 'antd'
import Amount from '../../../../components/Common/Amount'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import Remittances from '../../../../components/Purchasing/Voucher/AddVoucher/Remittances'
import VouchersLines from '../../../../components/Purchasing/Voucher/Lines/VouchersLines'
import VouchersForm from '../../../../components/Purchasing/Voucher/VouchersForm'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import OverrideActionButton from '../../../../elements/OverrideActionButton'
import Status from '../../../../elements/Status'
import { get, round, sum } from 'lodash'
import { dateFormat, dateVal, numVal, strVal } from '../../../../modules/Utils'
import moment from 'moment'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

const { TabPane } = Tabs

AddVoucher.propTypes = {}

function AddVoucher (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    fetchingActions,
    submit,
    fetch,
    update,
    formRef,
    actions,
    voucher,
    handleActions,
    lines,
    remove,
    removing,
  } = props

  const isConfirmed = ['Confirmed', 'Approved'].includes(voucher.status)
  const isOverrideable = ['Approved', 'Confirmed', 'Submitted', 'Resubmitted', 'Paid', 'Draft'].includes(
    voucher.status,
  )
  const within30Days = moment().diff(dateVal(voucher, 'billDate'), 'days') + 1 > 30 || moment().diff(dateVal(voucher, 'billDate'), 'days') < 0

  const Operations = ({ voucher, ...rest }) => {
    let ops = actions
      .filter(a => a.key !== 'update' && a.key !== 'remove')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    isConfirmed &&
    ops.push(
      <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Mark As Paid?`}
            onConfirm={() => handleActions('paid')}
            okText="Yes"
            cancelText="No">
            <a>Mark As Paid</a>
          </Popconfirm>
        </span>,
    )

    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }
  const isNew = type === 'new'
  const SubmitButton = () => (
    <FooterButtons
      style={{ float: 'right', marginBottom: 10 }}
      remove={remove}
      removing={removing}
      isRemovable={!isConfirmed}
      submit={submit}
      isUpdatable={!isConfirmed}
      update={update}
      submitting={submitting || updating}
      title={'Voucher'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )

  return (
    <CustomSpin spinning={fetching || fetchingActions}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/purchasing/vouchers`}>Vouchers</Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'new' ? 'New Voucher' : voucher.code}</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Voucher</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <h2 className={'icon-text-header'}>
                    <Icon
                      type="barcode"
                      style={{
                        marginRight: '5px',
                        color: '#08c',
                      }}
                    />
                    <Tooltip title="Voucher Code">{strVal(voucher, 'code')}</Tooltip>
                  </h2>
                  <Status value={strVal(voucher, 'status')}/>

                  <Operations
                    style={{ marginTop: '10px' }}
                    voucher={voucher}
                    status={strVal(voucher, 'status')}
                  />
                  {isOverrideable && within30Days && (
                    <OverrideActionButton
                      {...{
                        fetch,
                        doc: voucher._id,
                        company: strVal(voucher, 'company._id'),
                        override: strVal(voucher, 'override'),
                      }}
                    />
                  )}
                  <br/>

                  <>
                    {get(voucher, 'paid') !== 0 &&
                    get(voucher, 'paid') === get(voucher, 'amount') ? (
                      <Tag color={'#48c94c'}>Paid</Tag>
                    ) : (
                      <>
                        {voucher.urgent === true && <Tag color={'red'}>Urgent</Tag>}
                        {get(voucher, 'scheduledDate') && (
                          <Tooltip title={dateFormat(moment(get(voucher, 'scheduledDate')))}>
                            <Tag color={'#ff9909'}>Scheduled</Tag>
                          </Tooltip>
                        )}
                      </>
                    )}
                  </>
                </h3>
              </Col>
              <Col span={5}>
                <Amount
                  data={[
                    {
                      name: 'SUB-TOTAL',
                      amount: round(
                        sum(
                          lines
                            .filter(l => l.isNonPayAndLoss !== true)
                            .map(d => numVal(d, 'amount.net')),
                        ) *
                        get(voucher, 'vPercent', 100) *
                        0.01,
                        2,
                      ),
                    },
                    {
                      name: 'TAX',
                      amount: round(
                        sum(
                          lines
                            .filter(l => l.isNonPayAndLoss !== true)
                            .map(d => numVal(d, 'amount.tax')),
                        ) *
                        get(voucher, 'vPercent', 100) *
                        0.01,
                        2,
                      ),
                    },
                    {
                      name: 'TOTAL',
                      amount: round(
                        sum(
                          lines
                            .filter(l => l.isNonPayAndLoss !== true)
                            .map(d => numVal(d, 'amount.gross')),
                        ) *
                        get(voucher, 'vPercent', 100) *
                        0.01,
                        2,
                      ),
                    },
                  ]}
                  currency={voucher.currency}
                />
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs
          defaultActiveKey={get(props, 'location.hash') || '#details'}
          onChange={key => props.history.push(key)}>
          <TabPane
            tab={
              <span>
                <Icon type="info-circle"/>
                Details
              </span>
            }
            key="#details">
            <Row>
              <SubmitButton/>
            </Row>
            <VouchersForm isNew={isNew} isConfirmed={isConfirmed} ref={formRef} {...props} />
            <Row>
              <SubmitButton/>
            </Row>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list"/> Lines
              </span>
            }
            key="#lines">
            <VouchersLines {...props} />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list"/> Remittances
              </span>
            }
            key="#remittances">
            <Remittances voucher={voucher}/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="copy"/>
                History
              </span>
            }
            key="#history">
            <History isArray={true} loading={fetching} owner={voucher}/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="folder-open"/>
                Documents
              </span>
            }
            key="#docs">
            <DocumentsCont email={true} emailLabel={'Email with Voucher'} owner={voucher}/>
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default withRouter(AddVoucher)
